"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const useSubscribeData_1 = require("./useSubscribeData");
function useGetDevice() {
    var _a;
    return (_a = (0, useSubscribeData_1.default)('game', 'device_os')) !== null && _a !== void 0 ? _a : '';
}
exports.default = useGetDevice;
